import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import Dropzone from 'react-dropzone'
import { toast } from 'react-toastify'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'
import SelectorInput from '../Shared/SelectorInput'

import {
    updateInputs,
    showHideModalAddDelegados,
    AddDelegado,
    SelectTipoSolicitud
} from '../../actions/delegados'

import { 
    showModalSelector, 
    selectFromSelector,
} from '../../actions/common'

class ModalAddDelegado extends Component {

    componentDidUpdate() {
        if (!this.props.user.get('es_superusuario')) {
            this.props.updateInputs('modalAddDelegado.data.responsable_cenco', this.props.user, false)
        }
    }

    handleCloseModal = () => {
        const modal = document.getElementById('ModalAddDelegado')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#ModalAddDelegado .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => this.props.showHideModalAddDelegados(false), 300)
    }

    handleSave = (e) => {
        this.props.AddDelegado()
        this.handleCloseModal(e, "ModalAddDelegado")

    }

    handleOpenSelector = (path, url = '/usuarios/cencos') => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_DELEGADOS', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, url, fn)
    }

    handleOpenSelectorAddCenco = (path) => {
        let columns = [
            { id: 1, caption: 'Codigo', value: 'codigo', width: '30%' },
            { id: 2, caption: 'Descripcion', value: 'descripcion', width: '70%' }   
		]

        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_DELEGADOS', payload)
        }
        const customFilter = { column: 'T0.responsable_id', operator: '===', value: this.props.modalAddDelegado.getIn(['data', 'responsable_cenco', 'id']), comparison: 'string' }
        this.props.showModalSelector('Listado de CENCOS', columns, '/cencos', fn, customFilter)
	}

    render() {

        const { modalAddDelegado, parametros, user } = this.props

        return(
            <Modal id="ModalAddDelegado" show={ modalAddDelegado.get('show') } ZIndex={ 2000 }>
                <ModalHeader title={ modalAddDelegado.get('title') } onClose={ e => this.handleCloseModal(e, "ModalAddDelegado") } />
                <ModalButtonStrip>
                    <BoxButton
                        name="floppy-o"
                        title="Guardar"
                        onClick={ e => this.handleSave(e) }
                        disabled = {false }
                    />
                </ModalButtonStrip>
                <ModalBody>
                    <div style={{ width: '600px' }}>
						<div className="row" style={{ marginTop: '10px' }}>
							<div className="col-md-12">
                                <div className="form-group">
                                    <label className="control-label">Responsable de cenco</label>
                                    { user.get('es_superusuario') ? 
                                        <SelectorInput value={modalAddDelegado.getIn(['data', 'responsable_cenco', 'fullname']) || ''}
                                                onClick={() => this.handleOpenSelector(`modalAddDelegado.data.responsable_cenco`)}
                                                onReset={() => this.props.updateInputs(`modalAddDelegado.data.responsable_cenco`, null)} />
                                        :<input type="text" disabled={true} className="form-control input-sm"
                                                value={modalAddDelegado.getIn(['data', 'responsable_cenco', 'fullname']) || ''} />
                                    }
                                </div>
                                <div className="form-group">
									<label className="control-label">Cenco</label>
                                    { modalAddDelegado.getIn(['data', 'responsable_cenco']) ?
                                        <SelectorInput value={modalAddDelegado.getIn(['data', 'cenco', 'descripcion']) || ''}
                                                onClick={() => this.handleOpenSelectorAddCenco(`modalAddDelegado.data.cenco`)}
                                                onReset={() => this.props.updateInputs(`modalAddDelegado.data.cenco`, null)} />
                                        :<input type="text" disabled={true} className="form-control input-sm"
                                                value={modalAddDelegado.getIn(['data', 'cenco', 'descripcion']) || ''} />
                                    }
								</div>
                                <div className="form-group">
                                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-delegados">
                                        <thead>
                                            <tr>
                                                <th width="10"></th>
                                                <th>Tipo de Solicitud</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {parametros && parametros.map(ele => 
                                                <tr key={`tipo[${ele.get('TIPO_SOLICITUD')}]`}>
                                                    <td><input type="checkbox" checked={modalAddDelegado.getIn(['data','tipo_solicitud']).indexOf(ele.get("TIPO_SOLICITUD")) >= 0}
                                                        onChange={(e) => this.props.SelectTipoSolicitud(ele.get("TIPO_SOLICITUD"), e.target.checked)}/></td>
                                                    <td>{ele.get("SOLICITUD")}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
								</div>
                                <div className="form-group">
                                    <label className="control-label">Usuario a delegar</label>
                                    <SelectorInput value={modalAddDelegado.getIn(['data', 'delegado', 'fullname']) || ''}
                                                onClick={() => this.handleOpenSelector(`modalAddDelegado.data.delegado`, '/usuarios/ldap')}
                                                onReset={() => this.props.updateInputs(`modalAddDelegado.data.delegado`, null)} />
                                </div>
							</div>
						</div>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
            
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalAddDelegado: state.delegados.get('modalAddDelegado'),
        parametros: state.common.getIn(['parametros', 'SOLICITUDES']),
        user: state.common.get('user'),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        SelectTipoSolicitud: (tipo_solicitud, check) => dispatch(SelectTipoSolicitud(tipo_solicitud, check)),
        showHideModalAddDelegados: (show) => dispatch(showHideModalAddDelegados(show)),
        updateInputs: (path, value, immutable) => dispatch(updateInputs(path, value, immutable)),
        AddDelegado: () => dispatch(AddDelegado()),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),   
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddDelegado)


// WEBPACK FOOTER //
// ./src/components/Delegados/ModalAddDelegados.jsx